import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | joined | exists | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email || state === "loading") return;
    setState("loading");
    try {
      const payload = { email };
      if (name.trim()) payload.name = name.trim();
      const res = await axios.post(`${API}/waitlist`, payload);
      setState(res.data.status === "exists" ? "exists" : "joined");
    } catch (err) {
      setState("idle");
      toast.error("Something went wrong. Please try again.");
    }
  };

  if (state === "joined" || state === "exists") {
    return (
      <motion.div
        data-testid="waitlist-success-message"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="flex items-center gap-4 rounded-3xl border border-[rgba(195,153,83,0.3)] bg-white/80 px-6 py-5 backdrop-blur-xl"
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold-dark">
          <Check size={18} />
        </span>
        <div>
          <p className="font-serif text-xl text-ink">
            {state === "joined" ? "You're on the list." : "You're already on the list."}
          </p>
          <p className="text-sm text-[#5C5450]">
            We'll write to you the moment 841 is ready for you.
          </p>
        </div>
      </motion.div>
    );
  }

  return (
    <form
      data-testid="waitlist-form"
      onSubmit={submit}
      className={`flex w-full flex-col gap-3 ${compact ? "max-w-md" : "max-w-lg"}`}
    >
      <input
        data-testid="waitlist-name-input"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Your name (optional)"
        className="rounded-full border border-[rgba(26,24,23,0.14)] bg-white px-6 py-4 text-sm text-ink placeholder:text-[#8A8079] outline-none transition-colors duration-300 focus:border-gold"
      />
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          data-testid="waitlist-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 rounded-full border border-[rgba(26,24,23,0.14)] bg-white px-6 py-4 text-sm text-ink placeholder:text-[#8A8079] outline-none transition-colors duration-300 focus:border-gold"
        />
        <button
          data-testid="waitlist-submit-button"
          type="submit"
          disabled={state === "loading"}
          className="rounded-full bg-ink px-8 py-4 text-sm tracking-wide text-sand transition-colors duration-300 hover:bg-gold-dark disabled:opacity-60"
        >
          {state === "loading" ? "Joining…" : "Join the waitlist"}
        </button>
      </div>
    </form>
  );
};
